import { createSlice } from "@reduxjs/toolkit";
import { getSalesLeads } from "./actionsalesLeads";

const initialState = {
  data: [],
  isLoading: false,
  isSuccess: false,
  errorMessage: ''
}

export const salesLeads = createSlice({
  name: 'leads',
  initialState,
  extraReducers: {
    [getSalesLeads.pending]: (state) => {
      state.isLoading = true;
    },
    [getSalesLeads.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = payload;
    },
    [getSalesLeads.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = payload
    }
  }
})

export default salesLeads.reducer;